import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:max-w-[666px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-6" }, [
  /*#__PURE__*/_createTextVNode("Rodzaj skierowania "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "error-message" }

import { useField } from 'vee-validate';
import { ref } from 'vue';
import Select from '../../ui/Select.vue';


export default {
  __name: 'ReferralTypeSelect',
  setup(__props) {

const options = ref([
    {
        id: 'ct',
        title: 'e-Skierowanie na CT (Tomografia komputerowa)',
    },
    {
        id: 'mri',
        title: 'e-Skierowanie na MRI (Rezonans magnetyczny)',
    },
    {
        id: 'rtg',
        title: 'e-Skierowanie na RTG (Rentgen)',
    },
]);

const { value, errorMessage, setValue } = useField('referralType');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Select, {
      options: options.value,
      selected: _unref(value),
      onOnChange: _unref(setValue)
    }, null, 8, ["options", "selected", "onOnChange"]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1)
  ]))
}
}

}